/*
 * This file is a generated Typescript file for GRPC Gateway, DO NOT MODIFY
 */

import * as fm from "../../../fm"

import * as controlAccessControlV1 from "./keyapis_access_control_access_control_v1.pb"

/**
 * Сервис массового оповещения через домофоны
 */

/**
 * Сервис для массового оповещения через домофоны
 */
export class BroadcastAlertServiceClient {
  /**
   * Конструктор сервиса
   * @param host Адрес хоста
   * @param token Токен доступа
   */
  constructor(
    public host = "",
    public token = ""
  ) { }

  /**
   * Метод запуска массового оповещения через домофоны.
   * Метод доступен для: ApiKey
   */
  PostBroadcastAlertStart = (req: PostBroadcastAlertStartRequestDto, init?: RequestInit): Promise<PostBroadcastAlertStartResponseDto> => {
    return fm.request<PostBroadcastAlertStartRequestDto, PostBroadcastAlertStartResponseDto>(`${this.host}/access_control/internal/api/v1/broadcast_alert/start`, { ...init, method: "POST", body: JSON.stringify(req, fm.replacer), ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод прекращения массового оповещения через домофоны.
   * Метод доступен для: ApiKey
   */
  PostBroadcastAlertStop = (req?: PostBroadcastAlertStopRequestDto, init?: RequestInit): Promise<PostBroadcastAlertStopResponseDto> => {
    return fm.request<PostBroadcastAlertStopRequestDto, PostBroadcastAlertStopResponseDto>(`${this.host}/access_control/internal/api/v1/broadcast_alert/stop`, { ...init, method: "POST", body: JSON.stringify(req, fm.replacer), ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

}

/**
 * Тип проигрывания.
 */
export enum PostBroadcastAlertStartRequestPlayType {
  /**
   * Значение не указано
   */
  PLAY_TYPE_UNKNOWN = "PLAY_TYPE_UNKNOWN",
  /**
   * Только на аналоговые трубки
   */
  HANDSET_ONLY = "HANDSET_ONLY",
  /**
   * Tолько на динамик домофона
   */
  SPEAKER_ONLY = "SPEAKER_ONLY",
  /**
   * Сначала на аналоговые трубки проигрываем заданное количество тактов, затем на динамик домофона
   */
  HANDSET_AND_SPEAKER = "HANDSET_AND_SPEAKER",
  /**
   * Сначала на динамик домофона проигрываем заданное количество тактов, затем на аналоговые трубки
   */
  SPEAKER_AND_HANDSET = "SPEAKER_AND_HANDSET",
}
/**
 * Тип проигрывания.
 */
export type PostBroadcastAlertStartRequestPlayTypeResponseEnum = keyof typeof PostBroadcastAlertStartRequestPlayType
/**
 * Тип проигрывания.
 */
export type PostBroadcastAlertStartRequestPlayTypeRequestEnum = Exclude<PostBroadcastAlertStartRequestPlayTypeResponseEnum, "PLAY_TYPE_UNKNOWN">;

/**
 * Запрос на запуск массового оповещения через домофоны
 */
export type PostBroadcastAlertStartRequestDto = {
  /**
   * Ссылка на звуковой файл для проигрывания.
   * Файл должен лежать на внутреннем хранилище.
   * # Диапазон: 2..100
   */
  soundFileUri: string
  /**
   * Массив ОРПОНов домов, на которых запускаем проигрывание.
   * # Диапазон: 1..100
   */
  orpons?: string[]
  /**
   * Длительность воспроизведения такта в секундах.
   * Такт включает в себя проигрывание файла на трубках или на динамике.
   * # Диапазон: 0..65536
   */
  tactPlayDuration: number
  /**
   * Количество последовательных повторов тактов перед сменой динамика на трубки или наоборот.
   * # Диапазон: 0..65536
   */
  tactRepeatCount: number
  /**
   * Количество дополнительных повторов тактов, т.е. умолчание=0 - это проигрывание одного такта.
   * # Диапазон: 0..65536
   */
  playRepeatCount: number
  /**
   * Тип проигрывания
   */
  playType: PostBroadcastAlertStartRequestPlayTypeRequestEnum
}
/**
 * Ответ на запрос на запуск массового оповещения через домофоны
 */
export type PostBroadcastAlertStartResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Ошибка
   */
  readonly error: PostBroadcastAlertStartResponseErrorDto
}>
/**
 * Ошибка запроса
 */
export type PostBroadcastAlertStartResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: controlAccessControlV1.ValidationErrorRequestDto
  /**
   * Звуковой файл не найден
   */
  readonly soundFileNotFound: PostBroadcastAlertStartResponseErrorSoundFileNotFoundRequestDto
}>
/**
 * Ошибка запроса
 */
export type PostBroadcastAlertStartResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: controlAccessControlV1.ValidationErrorResponseDto
  /**
   * Звуковой файл не найден
   */
  readonly soundFileNotFound: PostBroadcastAlertStartResponseErrorSoundFileNotFoundDto
}>
/**
 * Звуковой файл не найден
 */
export type PostBroadcastAlertStartResponseErrorSoundFileNotFoundRequestDto = {
}
/**
 * Звуковой файл не найден
 */
export type PostBroadcastAlertStartResponseErrorSoundFileNotFoundDto = {
}
/**
 * Запрос на прекращение массового оповещения через домофоны
 */
export type PostBroadcastAlertStopRequestDto = {
  /**
   * Массив ОРПОНов домов, на которых запускаем проигрывание.
   * # Диапазон: 1..100
   */
  orpons?: string[]
}
/**
 * Ответ на запрос на прекращение массового оповещения через домофоны
 */
export type PostBroadcastAlertStopResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Ошибка
   */
  readonly error: PostBroadcastAlertStopResponseErrorDto
}>
/**
 * Ошибка запроса
 */
export type PostBroadcastAlertStopResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: controlAccessControlV1.ValidationErrorRequestDto
}>
/**
 * Ошибка запроса
 */
export type PostBroadcastAlertStopResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: controlAccessControlV1.ValidationErrorResponseDto
}>
/**
 * Дескриптор
 */
export const descriptor = {
  /**
   * Запрос на запуск массового оповещения через домофоны
   */
  "PostBroadcastAlertStartRequest": {
    "kind": "class",
    "text": "Запрос на запуск массового оповещения через домофоны",
    "fields": {
      /**
       * Ссылка на звуковой файл для проигрывания.
       * Файл должен лежать на внутреннем хранилище.
       * # Диапазон: 2..100
       */
      "soundFileUri": {
        "type": "string",
        "text": "Ссылка на звуковой файл для проигрывания.\nФайл должен лежать на внутреннем хранилище.\n# Диапазон: 2..100",
        "rules": {
          "required": "Значение обязательно для заполнения",
          "minLength": {
            "value": 2,
            "message": "Значение не входит в допустимый диапазон. Минимум: 2"
          },
          "maxLength": {
            "value": 100,
            "message": "Значение не входит в допустимый диапазон. Максимум: 100"
          },
        }
      },
      /**
       * Массив ОРПОНов домов, на которых запускаем проигрывание.
       * # Диапазон: 1..100
       */
      "orpons": {
        "type": "int64",
        "text": "Массив ОРПОНов домов, на которых запускаем проигрывание.\n# Диапазон: 1..100",
        "rules": {
          "min": {
            "value": 1,
            "message": "Значение не входит в допустимый диапазон. Минимум: 1"
          },
          "max": {
            "value": 100,
            "message": "Значение не входит в допустимый диапазон. Максимум: 100"
          },
        }
      },
      /**
       * Длительность воспроизведения такта в секундах.
       * Такт включает в себя проигрывание файла на трубках или на динамике.
       * # Диапазон: 0..65536
       */
      "tactPlayDuration": {
        "type": "int32",
        "text": "Длительность воспроизведения такта в секундах.\nТакт включает в себя проигрывание файла на трубках или на динамике.\n# Диапазон: 0..65536",
        "rules": {
          "required": "Значение обязательно для заполнения",
          "min": {
            "value": 0,
            "message": "Значение не входит в допустимый диапазон. Минимум: 0"
          },
          "max": {
            "value": 65536,
            "message": "Значение не входит в допустимый диапазон. Максимум: 65536"
          },
        }
      },
      /**
       * Количество последовательных повторов тактов перед сменой динамика на трубки или наоборот.
       * # Диапазон: 0..65536
       */
      "tactRepeatCount": {
        "type": "int32",
        "text": "Количество последовательных повторов тактов перед сменой динамика на трубки или наоборот.\n# Диапазон: 0..65536",
        "rules": {
          "required": "Значение обязательно для заполнения",
          "min": {
            "value": 0,
            "message": "Значение не входит в допустимый диапазон. Минимум: 0"
          },
          "max": {
            "value": 65536,
            "message": "Значение не входит в допустимый диапазон. Максимум: 65536"
          },
        }
      },
      /**
       * Количество дополнительных повторов тактов, т.е. умолчание=0 - это проигрывание одного такта.
       * # Диапазон: 0..65536
       */
      "playRepeatCount": {
        "type": "int32",
        "text": "Количество дополнительных повторов тактов, т.е. умолчание=0 - это проигрывание одного такта.\n# Диапазон: 0..65536",
        "rules": {
          "required": "Значение обязательно для заполнения",
          "min": {
            "value": 0,
            "message": "Значение не входит в допустимый диапазон. Минимум: 0"
          },
          "max": {
            "value": 65536,
            "message": "Значение не входит в допустимый диапазон. Максимум: 65536"
          },
        }
      },
      /**
       * Тип проигрывания
       */
      "playType": {
        "type": "PostBroadcastAlertStartRequest.PlayType",
        "text": "Тип проигрывания",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Ответ на запрос на запуск массового оповещения через домофоны
   */
  "PostBroadcastAlertStartResponse": {
    "kind": "class",
    "text": "Ответ на запрос на запуск массового оповещения через домофоны",
    "fields": {
      /**
       * Ошибка
       */
      "error": {
        "type": "PostBroadcastAlertStartResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка запроса
   */
  "PostBroadcastAlertStartResponse.Error": {
    "kind": "class",
    "text": "Ошибка запроса",
    "fields": {
      /**
       * Ошибка валидации
       */
      "validation": {
        "type": "ValidationError",
        "text": "Ошибка валидации",
      },
      /**
       * Звуковой файл не найден
       */
      "soundFileNotFound": {
        "type": "PostBroadcastAlertStartResponse.Error.SoundFileNotFound",
        "text": "Звуковой файл не найден",
      },
    },
  },
  /**
   * Звуковой файл не найден
   */
  "PostBroadcastAlertStartResponse.Error.SoundFileNotFound": {
    "kind": "class",
    "text": "Звуковой файл не найден",
  },
  /**
   * Запрос на прекращение массового оповещения через домофоны
   */
  "PostBroadcastAlertStopRequest": {
    "kind": "class",
    "text": "Запрос на прекращение массового оповещения через домофоны",
    "fields": {
      /**
       * Массив ОРПОНов домов, на которых запускаем проигрывание.
       * # Диапазон: 1..100
       */
      "orpons": {
        "type": "int64",
        "text": "Массив ОРПОНов домов, на которых запускаем проигрывание.\n# Диапазон: 1..100",
        "rules": {
          "min": {
            "value": 1,
            "message": "Значение не входит в допустимый диапазон. Минимум: 1"
          },
          "max": {
            "value": 100,
            "message": "Значение не входит в допустимый диапазон. Максимум: 100"
          },
        }
      },
    },
  },
  /**
   * Ответ на запрос на прекращение массового оповещения через домофоны
   */
  "PostBroadcastAlertStopResponse": {
    "kind": "class",
    "text": "Ответ на запрос на прекращение массового оповещения через домофоны",
    "fields": {
      /**
       * Ошибка
       */
      "error": {
        "type": "PostBroadcastAlertStopResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка запроса
   */
  "PostBroadcastAlertStopResponse.Error": {
    "kind": "class",
    "text": "Ошибка запроса",
    "fields": {
      /**
       * Ошибка валидации
       */
      "validation": {
        "type": "ValidationError",
        "text": "Ошибка валидации",
      },
    },
  },
  /**
   * Тип проигрывания.
   */
  "PostBroadcastAlertStartRequest.PlayType": {
    "kind": "enum",
    "text": "Тип проигрывания.",
    "values": {
      /**
       * Значение не указано
       */
      "PLAY_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * Только на аналоговые трубки
       */
      "HANDSET_ONLY": {
        "i": 1,
        "text": "Только на аналоговые трубки",
      },
      /**
       * Tолько на динамик домофона
       */
      "SPEAKER_ONLY": {
        "i": 2,
        "text": "Tолько на динамик домофона",
      },
      /**
       * Сначала на аналоговые трубки проигрываем заданное количество тактов, затем на динамик домофона
       */
      "HANDSET_AND_SPEAKER": {
        "i": 3,
        "text": "Сначала на аналоговые трубки проигрываем заданное количество тактов, затем на динамик домофона",
      },
      /**
       * Сначала на динамик домофона проигрываем заданное количество тактов, затем на аналоговые трубки
       */
      "SPEAKER_AND_HANDSET": {
        "i": 4,
        "text": "Сначала на динамик домофона проигрываем заданное количество тактов, затем на аналоговые трубки",
      },
    },
  },
}